// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__1H38F","log":"ModalInventoryLogs_log__Z1Hg_","date":"ModalInventoryLogs_date__2fKW-","userName":"ModalInventoryLogs_userName__1nsLv"};